<template>
  <span>{{ resolvedQuestion }}</span>
</template>

<script>
export default {
  name: 'QuestionRenderer',
  props: {
    question: {
      type: String
    },
    placeholders: {
      type: Object
    }
  },
  computed: {
    resolvedQuestion: function() {
      return this.question.replace('{brand_name}', this.placeholders.brand_name)
    }
  }
}
</script>

<style scoped></style>
